<template>
  <v-container id="user_groups_root" fluid>
    <!-- DIALOG -->
    <v-row justify="center" align="center">
      <v-dialog
        v-model="showDialog" max-width="800"
      >
        <create-or-add-users-to-group
          :key="modalKeyCnt"
          :ba-id="baId"
          :update-mode="modalUpdateMode"
          :user-group-id="!!chosenUserGroup ? chosenUserGroup.id : undefined"
          @finished="handleDialog"
        ></create-or-add-users-to-group>
      </v-dialog>
    </v-row>
    <!-- CONTENT -->
    <v-row class="mb-6 px-6" align="center" justify="center">
      <v-col class="d-flex flex-row">
        <v-btn id="create_group_btn" class="align-self-end mr-8" color="primary" @click="showCreateOrUpdateDialog(false)">
          <v-icon left>mdi-plus-circle-outline</v-icon>
          {{ $t('userGroups.content.createGroup') }}
        </v-btn>
        <v-text-field
          id="group_search_field"
          v-model="search"
          :label="$t('dataTable.search')"
          append-icon="mdi-magnify"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>

    <v-card>
      <v-data-table
        id="group_table"
        must-sort
        :headers="headers"
        :items="userGroupList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :loading="dataTableLoading"
        :loading-text="$t('dataTable.content.loadingPleaseWait')"
        :no-data-text="$t('dataTable.content.noDataAvailable')"
        :footer-props="{
          'items-per-page-text': $t('dataTable.footer.itemsPerPageText'),
          'page-text': $t('dataTable.footer.pageText'),
          'items-per-page-options': [5,10,25,50],
        }"
      >
        <template #[`item.actions`]="{ item }">
          <v-btn
            id="update_group"
            text
            class="pa-1 "
            @click="showCreateOrUpdateDialog(true, item)"
          >
            <v-icon>mdi-cog-outline</v-icon>
            {{ $t('dataTable.content.action.update') }}
          </v-btn>

          <v-btn
            id="delete_group"
            text
            class="pa-1 "
            @click="deleteUserGroup(item.id,$event)"
          >
            <v-icon>mdi-delete</v-icon>
            {{ $t("dataTable.content.action.delete") }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import usergroups from '@/services/api/userGroups.js'
import { showConfirmationMenu, showToastError, showToastSuccess } from '../../../event-bus'
import debounce from 'lodash.debounce'
import CreateOrAddUsersToGroup from './CreateOrAddUsersToGroup.vue'

export default {
  components: { CreateOrAddUsersToGroup },
  props: {
    baId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('dataTable.header.users.id'),
          align: 'left',
          value: 'id'
        },
        {
          text: this.$t('userGroups.content.name'),
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t('userGroups.content.count'),
          align: 'left',
          value: 'memberCount'
        },
        {
          text: this.$t('dataTable.header.actions'),
          align: 'right',
          value: 'actions',
          sortable: false
        }

      ],
      userGroupList: [],
      search: '',
      showDialog: false,
      chosenUserGroup: undefined,
      dataTableLoading: false,
      totalItems: 0,
      chosenGroupId: 0,
      pagination: {
        page: 1,
        itemsPerPage: 5,
        sortBy: ['name']
      },
      modalKeyCnt: 0,
      modalUpdateMode: false
    }
  },
  watch: {
    search() {
      this.dataTableLoading = true
      this.searchUserGroupsWatcher()
    },
    pagination: {
      handler() {
        this.searchUserGroups()
      }
    }

  },
  mounted() {
    this.searchUserGroups()
  },
  methods: {
    async searchUserGroups() {
      this.dataTableLoading = true
      try {
        const pageRequest = {
          'page.num': this.pagination.page,
          'page-size': this.pagination.itemsPerPage || 5,
          'sort-field': this.pagination.sortBy[0],
          'sort-order': this.pagination.sortDesc[0] ? 'desc' : 'asc'
        }
        const page = await usergroups.listUserGroups(this.search, pageRequest)
        // const page = await usergroups.listUserGroups(this.search, undefined)
        // const page = await usergroups.listUserGroups(undefined, undefined)

        this.userGroupList = page.content
        this.totalItems = page.total
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      } finally {
        this.dataTableLoading = false
      }
    },
    searchUserGroupsWatcher: debounce(function() {
      this.searchUserGroups()
    }, 500),
    handleDialog() {
      this.showDialog = false
      this.chosenUserGroup = undefined
      this.searchUserGroups()
    },
    async showCreateOrUpdateDialog(isUpdate, item) {
      if (isUpdate) {
        this.chosenUserGroup = item
      }
      this.modalUpdateMode = isUpdate
      this.modalKeyCnt = this.modalKeyCnt + 1
      this.showDialog = true
    },
    async deleteUserGroup(id, e) {
      const opts = {
        title: this.$t('dialog.confirmation.title'),
        posX: e.clientX,
        posY: e.clientY
      }
      const conf = await showConfirmationMenu(opts)
      if (!conf) {
        return
      }

      try {
        await usergroups.deleteUserGroup(id)
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
        this.searchUserGroupsWatcher()
      } catch (error) {
        console.error(error)
        showToastError(this.getErrorMessage(error))
      }
    }

  }

}
</script>
